import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Table,
  TabContent,
  TabPane,
  Button,
  FormFeedback,
  CustomInput,
  Spinner,
} from "reactstrap";

//import images

import { useDispatch } from "react-redux";
import CommonLoading from "../../Components/Common/CommonLoading";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import { useSelector } from "react-redux";
import { annexure_detailsThunk } from "../../slices/thunks";
import classnames from "classnames";
import { formatDateToday, getCurrentFinancialYearRange } from "../../Components/Common/WorkingDateRange";
import exportToPDF_Annexure from "../../Components/Common/exportToPDF_Annexure";

const Annexure_10DB = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { userData } = usePersistStoreData();

  const token = userData?.token;
  const { annexureDetailsData, annexureDetailsLoading } = useSelector(
    (state) => state.Annexure_Get_Details
  );
  const tableDataPdf = annexureDetailsData?.security_trasanction_details;
  const currentDatePdf = formatDateToday();


  const [loading, setLoading] = useState(false);

  const assesseeDetails = [
    { label: "Name:", key: annexureDetailsData?.assential_details?.name },
    {
      label: "Address:",
      key: annexureDetailsData?.assential_details?.address,
    },
    { label: "MAPIN:", key: "-" },
    { label: "PAN No:", key: annexureDetailsData?.assential_details?.pan },
    { label: "Stock Exchange:", key: "National Stock Exchange of India" },
    { label: "Financial Year:", key: annexureDetailsData?.assential_details?.financial_year },
    { label: "Broker Member ID:", key: "07141" },
  ];

  const stockBrokerDetails = [
    { label: "Name:", key: "B N RATHI SECURITIES LIMITED" },
    {
      label: "Address:",
      key: "6-3-652, 4th floor Kautilya Amrutha Estates Somajiguda, Hyderabad-500082",
    },
  ];

  const ruleData = [
    {
      sno: 1,
      particulars:
        "Purchase of an equity share in a company or a unit of an equity oriented fund, where - 01",
    },
    {
      sno: "(a)",
      particulars:
        "the transaction of such purchase is entered into in a recognised stock exchange ; and",
    },
    {
      sno: "(b)",
      particulars:
        "the contract for the purchase of such share or unit is settled by the actual delivery or transfer of such share or unit.",
    },
    {
      sno: 2,
      particulars:
        "Sale of an equity share in a company or a unit of an equity oriented fund, where - 02",
    },
    {
      sno: "(a)",
      particulars:
        "the transaction of such sale is entered into in a recognised stock exchange; and",
    },
    {
      sno: "(b)",
      particulars:
        "the contact for the sale of such share or unit is settled by the actual delivery or transfer of such share or unit.",
    },
    {
      sno: 3,
      particulars:
        "Sale of an equity share in a company or a unit of an equity oriented fund, where - 03",
    },
    {
      sno: "(a)",
      particulars:
        "the transaction of such sale is entered into in a recognised stock exchange; and",
    },
    {
      sno: "(b)",
      particulars:
        "the contact for the sale of such share or unit is settled otherwise than by the actual delivery or transfer of such share or unit.",
    },
    {
      sno: 4,
      particulars:
        "Sale of a derivative being 'option in securities', where the transaction of such sale is entered into in a recognise stock exchange.",
    },
    {
      sno: 5,
      particulars:
        "Sale of a derivative being 'futures', where the transaction of such sale is entered into in a recognised stock exchange.",
    },
    {
      sno: 6,
      particulars:
        "Excerise of a derivative being 'option in securities', where the transaction of such sale is entered into in a recognised stock exchange.",
    },
    {
      sno: 7,
      particulars:
        "Purchase of an equity share in a company or a unit of Physical Delivery in equity Derivative.",
    },
    {
      sno: 8,
      particulars:
        "Sale of an equity share in a company or a unit of Physical Delivery in equity Derivative.",
    },
  ];
  const columns = [
    { label: "Client Code Number (1) ", key: "client_code" },
    { label: "Code of Transaction (2) ", key: "index" },
    {
      label: "Value of Transaction Entered into during the Financial Year. (3)",
      key: "values_1",
    },
    {
      label:
        "Total Security Transaction Tax Collected from the Assessee During the Financial Year. (4)",
      key: "values_2",
    },
    {
      label:
        "Value of Transaction ( Include in Value Given in Column 3) Entered into the course of business by the Assessee. (5)",
      key: "",
    },
    {
      label:
        "Total Securities Transaction Tax Collected on Value of Transactions given in Column 5. (6)",
      key: "",
    },
  ];

  const details = annexureDetailsData?.security_trasanction_details || {};
  const maxLength = Math.max(
    ...columns.map((col) =>
      col.key && Array.isArray(details[col.key]) ? details[col.key].length : 1
    )
  );

  const tableData = Array.from({ length: maxLength }, (_, i) => {
    const row = {};
    columns.forEach((col) => {
      if (!col.key) {
        row[col.label] = ""; // Handle blank columns
      } else {
        const value = details[col.key];
        row[col.key] = Array.isArray(value)
          ? value[i] || ""
          : i === 0
          ? value
          : "";
      }
    });
    return row;
  });

  useEffect(() => {
    dispatch(annexure_detailsThunk({ token }));
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {annexureDetailsLoading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <>
              <div className="position-relative mx-n4 mt-n4">
                <div
                  className="profile-wid-bg profile-setting-img"
                  style={{ backgroundColor: "#01256D" }}
                >
                  {/* <img src={progileBg} className="profile-wid-img" alt="" /> */}
                  <div className="">
                    <div className="text-end p-3">
                      <div className="p-0 pe-2 ms-auto rounded-circle profile-photo-edit">
                        <Nav
                          pills
                          className=" animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1 d-flex justify-content-end"
                          role="tablist"
                        >
                          <NavItem>
                            <NavLink
                              style={{
                                backgroundColor: "transparent",
                                border: "1px solid #0FA67B",
                              }}
                              onClick={() => {
                                exportToPDF_Annexure(
                                  annexureDetailsData,
                                  tableDataPdf,
                                  ruleData,
                                  currentDatePdf
                                );
                              }}
                            >
                              <span className="">
                                Download PDF
                              </span>
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Row>
                <Col xxl={3} xl={3}>
                  <Card className="mt-n5">
                    <CardBody className="p-4">
                      <div className="text-center border-bottom mb-3">
                        <h5 className="fs-16 mb-3">Assessee Details</h5>
                      </div>
                      <div className="d-flex flex-column mb-0">
                        {assesseeDetails?.map((item, index) => (
                          <div
                            key={index}
                            className="d-flex align-items-center justify-content-between mb-2"
                          >
                            <p className="mb-0 ps-0 fs-p-sm w-50 fw-semibold text-start">
                              {item?.label}
                            </p>
                            <p className="mb-0 fs-p-sm w-50 text-start">
                              {" "}
                              {item?.key || "-"}
                            </p>
                          </div>
                        ))}
                      </div>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <div className="text-center border-bottom mb-3">
                        <h5 className="fs-16 mb-3">Stock Brokers Details</h5>
                      </div>
                      <div className="d-flex flex-column mb-0">
                        {stockBrokerDetails?.map((item, index) => (
                          <div
                            key={index}
                            className="d-flex align-items-center justify-content-between mb-2"
                          >
                            <p className="mb-0 ps-0 fs-p-sm w-50 fw-semibold text-start">
                              {item?.label}
                            </p>
                            <p className="mb-0 fs-p-sm w-50 text-start">
                              {" "}
                              {item?.key || "-"}
                            </p>
                          </div>
                        ))}
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col xxl={9} xl={9}>
                  <Card className="mt-xxl-n5 mt-xl-n5">
                    <CardHeader className="border-0">
                      <div className="d-flex align-items-center ps-2">
                        <span className="me-3 annexure_squareDot"></span>
                        <p className="fs-14 fw-medium text-start mb-0">
                          Details of Value of Securities Transactions and
                          Transaction Tax Collected
                        </p>
                      </div>
                    </CardHeader>
                    <CardBody className="p-4 pt-1">
                      <Row className="g-2">
                        <Col>
                          <div className="table-responsive">
                            <Table
                              hover
                              className="align-middle table-nowrap table-bordered"
                            >
                              <thead className="bg-gl-primary sticky-header">
                                <tr>
                                  {columns.map((col, idx) => (
                                    <th
                                      key={idx}
                                      style={{
                                        padding: "0.4rem",
                                        textAlign: "center",
                                        maxWidth: "200px",
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {col?.label}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {tableData?.map((row, rowIdx) => (
                                  <tr key={rowIdx}>
                                    {columns?.map((col, colIdx) => (
                                      <td
                                        key={colIdx}
                                        className="fw-medium"
                                        style={{
                                          textAlign:
                                            colIdx === 0 ? "start" : "end",
                                            whiteSpace: "normal",
                                            padding: "0.3rem",
                                            paddingLeft: "0.4rem"
                                        }}
                                      >
                                        {col.key === "index"
                                          ? (rowIdx + 1)
                                              .toString()
                                              .padStart(2, "0")
                                          : ["values_1", "values_2"].includes(
                                              col.key
                                            )
                                          ? new Intl.NumberFormat("en-IN", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            }).format(Number(row[col.key]) || 0)
                                          : row[col.key] ?? ""}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                              <tfoot className="table-footer sticky-footer">
                                <tr className="bg-gl-success">
                                  <th colSpan={2} style={{ textAlign: "end" }}>
                                    TOTAL
                                  </th>

                                  <th style={{ textAlign: "end" }}>
                                    {Number(
                                      annexureDetailsData
                                        ?.security_trasanction_details
                                        ?.total_values_1 ?? 0
                                    ).toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </th>
                                  <th style={{ textAlign: "end" }}>
                                    {Number(
                                      annexureDetailsData
                                        ?.security_trasanction_details
                                        ?.total_values_2 ?? 0
                                    ).toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </th>
                                  <th style={{ textAlign: "end" }}></th>
                                  <th style={{ textAlign: "end" }}></th>
                                </tr>
                              </tfoot>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  <Card className="">
                    <CardHeader className="border-0">
                      <div className="d-flex align-items-center ps-2">
                        <span className="me-3 annexure_squareDot"></span>
                        <p className="fs-16 fw-semibold text-start mb-0">
                          Codes in Respect of Taxable Securities Transaction.
                        </p>
                      </div>
                    </CardHeader>
                    <CardBody className="p-4 pt-1">
                      <Row className="g-2">
                        <Col>
                          <div className="table-responsive">
                            <Table
                              hover
                              className="align-middle table-nowrap table-bordered "
                            >
                              <thead className="bg-gl-primary sticky-header">
                                <tr>
                                  <th
                                    style={{
                                      padding: "0.4rem",
                                      textAlign: "center",
                                    }}
                                  >
                                    S. No
                                  </th>
                                  <th
                                    style={{
                                      padding: "0.4rem",
                                      textAlign: "center",
                                    }}
                                  >
                                    Nature of Transaction Code
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ruleData.map((item, index) => (
                                  <tr key={index}>
                                    <td style={{ textAlign: "start" }}>
                                      {item.sno}
                                    </td>
                                    <td style={{ textAlign: "start" }}>
                                      {item.particulars}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Annexure_10DB;
